export default "__VITE_ASSET__436e42b0__"